import { DetailsBody, JackpotBody, MobileAvmBody } from "./CreateFundBody";

const CreateFund = (props : any) => {

  return (
    props.page.details ? <DetailsBody /> : props.page.jackpot ? <JackpotBody/> : props.page.avm ? <MobileAvmBody /> : <></>
  );
  
};

export default CreateFund;